import React, { useEffect, useState } from "react";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import AddDayDetailsFormWrapper from "../AddDayDetails/AddDayDetailsFormWrapper";
import DayPlanningLayout from "./DayPlanningLayout";

type Props = {
  onAddDay: () => void;
  setSearchValue: any;
  searchValue: any;
  plansData: any;
  setPlanId: any;
  durationData: any;
  durationDataIsLoading: boolean;
  planId: any;
};

const DayPlanningListing = ({
  onAddDay,
  setSearchValue,
  searchValue,
  plansData,
  setPlanId,
  durationData,
  durationDataIsLoading,
  planId,
}: Props) => {
  const [selectDayData, setSelectDayData] = useState<any>({});


  useEffect(() => {
    setSelectDayData(durationData?.dayWisePlanning?.[0])
  }, [durationDataIsLoading, durationData])
  return (
    <div className="px-2 h-full">
      <div className="flex justify-end border-b-2 pb-2 h-full">
        <ATMLoadingButton className="w-40" onClick={onAddDay}>
          Create Plan
        </ATMLoadingButton>
      </div>
      {plansData?.length ? <div className="grid grid-cols-12 mt-2 gap-3 h-[62vh] lg:h-[75vh] overflow-scroll">
        <div className="col-span-2">
          <div className="text-[18px] font-medium text-primary-dark border-b-2 pb-1">Plans</div>
          <DayPlanningLayout
            searchValue={searchValue}
            onSearch={(value: any) => setSearchValue(value)}
            planId={planId}
            listData={plansData}
            onClickChangeRequestView={(id: any) => setPlanId(id)}
          />
        </div>
        <div className=" border-r col-span-3  px-2 grid grid-cols-1 gap-2 h-fit">
          <div className="text-[18px] font-medium text-primary-dark border-b-2 pb-1">Days</div>
          <div className=" max-h-[calc(100vh-250px)] overflow-y-auto">
            {durationDataIsLoading
              ? Array(10)
                .fill(0)
                .map((_, index) => {
                  return (
                    <div key={index} className="animate-pulse  h-[50px] p-2">
                      <div className="bg-slate-200 h-full rounded"> </div>
                    </div>
                  );
                })
              : durationData?.dayWisePlanning?.map((el: any, ind: number) => {
                return (
                  <div
                    key={ind}
                    className={`border border-slate-50 shadow-md my-3  p-2 font-medium  cursor-pointer h-fit ${selectDayData?._id === el?._id ? 'bg-cyan-100' : 'bg-slate-50'}`}
                    onClick={(() => { setSelectDayData(el) })}
                  >
                    <span className="flex justify-end items-start ">
                      {el?.day}
                    </span>

                  </div>
                );
              })}
          </div>
        </div>
        <div className="col-span-7">
          {" "}
          <AddDayDetailsFormWrapper selectDayData={selectDayData} planId={planId} />{" "}
        </div>
      </div> : <div className="flex justify-center items-end text-red-700 font-medium text-2xl h-[300px]">No Data Found</div>}
    </div>
  );
};

export default DayPlanningListing;
